import React from 'react';
import { noop, set } from 'lodash';
import classnames from 'classnames';
import styles from './index.less';
import SharingModal from '../SharingModal';
import * as CONSTANT from '../constant';
import CustomerContext from '../SharingModal/CustomerContext';
import { Button } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';

import track, { CLICK_SHARE_FROM_KEBAB } from '@src/utils/sensor/track';

const Sharing = ({
  url,
  id,
  isFetching,
  config,
  startShare,
  usecaseKey,
  title,
  cid,
  withIcon = false,
  RenderBtn = Button,
  className = '',
  isShareClicked = false,
  setShareClicked = noop,
}) => {
  const [visible, setVisible] = React.useState(false);

  const handleClick = React.useCallback(
    () => {
      if (usecaseKey) {
        set(config, 'state.usecaseKey', usecaseKey);
      }
      startShare(config);
      setVisible(true);
      track({ event: CLICK_SHARE_FROM_KEBAB });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, usecaseKey],
  );

  React.useEffect(() => {
    if (isShareClicked) {
      handleClick();
    }
  }, [isShareClicked, handleClick]);

  const hide = React.useCallback(
    () => {
      setVisible(false);
      if (setShareClicked) {
        setShareClicked(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible],
  );

  return (
    <>
      {!isShareClicked ? (
        withIcon ? (
          <RenderBtn onClick={handleClick} type="text" size="small" icon={<ShareAltOutlined />}>
            {CONSTANT.SHARE}
          </RenderBtn>
        ) : (
          <span
            className={classnames(styles.sharingWrapper, className)}
            onClick={handleClick}
            role="button"
            tabIndex={0}
          >
            <span>{CONSTANT.SHARE}</span>
          </span>
        )
      ) : null}
      <CustomerContext.Provider value={cid}>
        <SharingModal
          title={title}
          url={url}
          id={id}
          isFetching={isFetching}
          visible={visible}
          hide={hide}
        />
      </CustomerContext.Provider>
    </>
  );
};

export default Sharing;
